// import React, { useState } from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import useBatches from "src/hooks/useBatches";
import useStudents from "src/hooks/useStudents";
import useTests from "src/hooks/useTests";

import { AssignTestsFormValue } from "src/models/AssignTest.model";

type Props = {
  formikProps: FormikProps<AssignTestsFormValue>;
  editorValue?: string;
};

const QuestionTechnologyForm = ({
  formikProps,
}:
  Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  const { batches, isDataLoading: isBatchLoading } = useBatches();
  const { students, isDataLoading: isStudentsLoading } = useStudents();
  const { tests, isDataLoading: isTestSeriesLoading } = useTests();


  return (
    <div className="flex flex-col flex-1 gap-4 p-4 overflow-hidden">
      <div className="flex items-center justify-between h-fit">
        <div className="text-xl font-medium">
          Assign Test 
        </div>
        <div className="flex justify-end">
        <div className=" w-[200px]">
          <ATMLoadingButton isLoading={isSubmitting} type="submit">
            Save
          </ATMLoadingButton>
        </div>
      </div>
      </div>
      <div className="h-full grid gap-x-8 grid-cols-3">
        <div>
          <ATMSelect
            name="testId"
            required
            value={values?.testId}
            onChange={(newValue) => setFieldValue("testId", newValue)}
            onBlur={handleBlur}
            label="Test"
            placeholder="Select Test"
            options={
              tests?.map((test: any) => ({
                label: test?.testTitle,
                value: test?._id,
              })) || []
            }
            isLoading={isTestSeriesLoading}
          />
        </div>
        <div>
          <ATMSelect
            disabled={values.students.length ? true : false}
            name="batchId"
            required
            value={values?.batchId}
            onChange={(newValue) => {
              setFieldValue("batchId", newValue);
              setFieldValue("students", []);
            }}
            onBlur={handleBlur}
            label="Batch"
            isClearable
            placeholder="Select Batch"
            options={
              batches?.map((batch: any) => ({
                label: batch?.batchName,
                value: batch?._id,
              })) || []
            }
            isLoading={isBatchLoading}
          />
        </div>
        <div>
          <div className="col-span-full">
            <ATMMultiSelect
              disabled={values.batchId ? true : false}
              isMenuOpen={values.batchId ? false : true}
              name="branches"
              value={values.students}
              onChange={(newValue) => {
                setFieldValue("students", newValue);
                setFieldValue("batchId", null);
              }}
              onBlur={handleBlur}
              label="Students"
              placeholder="Select Students"
              options={students?.map((student: any) => ({
                label: student?.name,
                value: student?._id,
              }))}
              isLoading={isStudentsLoading}
            />
          </div>
        </div>
      </div>

   
    </div>
  );
};

export default QuestionTechnologyForm;
